export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const AI_BASE_URL = process.env.REACT_APP_AI_BASE_URL;
export const FIREBASE_MESSAGING_KEY = process.env.REACT_APP_VAPID_KEY;
export const BUILD_TYPE = process.env.REACT_APP_BUILD_TYPE;

// Wellpoint Max/Min values
export const WELLPOINT_MAX = 200000;
export const WELLPOINT_MIN = 1000;
export const WELLPOINT_STEP = 1000;
export const DEFAULT_VALUE = 100000;
